module.exports = __webpack_public_path__ + "img/budtender_hub.5745d8c9.png";